import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Waves, Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    if (location.pathname !== '/') {
      window.location.href = '/#property-form';
    } else {
      document.getElementById('property-form')?.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-lg shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-blue-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <Waves className="w-6 h-6 text-white" />
            </div>
            <span className={`text-2xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-slate-900' : 'text-white'
            }`}>
              Reflow
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className={`font-medium transition-colors duration-300 hover:text-emerald-500 ${
                isScrolled ? 'text-slate-700' : 'text-white/90'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/immobili" 
              className={`font-medium transition-colors duration-300 hover:text-emerald-500 ${
                isScrolled ? 'text-slate-700' : 'text-white/90'
              }`}
            >
              Cerchi casa?
            </Link>
            <Link 
              to="/vision" 
              className={`font-medium transition-colors duration-300 hover:text-emerald-500 ${
                isScrolled ? 'text-slate-700' : 'text-white/90'
              }`}
            >
              Vision
            </Link>
            <Button
              onClick={scrollToForm}
              className={`transition-all duration-300 ${
                isScrolled
                  ? 'bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white shadow-md'
                  : 'bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/20'
              }`}
            >
              Diventa Fondatore
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-slate-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 space-y-4 bg-white border-t border-slate-200 rounded-b-lg shadow-lg">
            <Link 
              to="/" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-slate-700 font-medium hover:text-emerald-500 hover:bg-slate-50 transition-colors rounded-lg"
            >
              Home
            </Link>
            <Link 
              to="/immobili" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-slate-700 font-medium hover:text-emerald-500 hover:bg-slate-50 transition-colors rounded-lg"
            >
              Cerchi casa?
            </Link>
            <Link 
              to="/vision" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-slate-700 font-medium hover:text-emerald-500 hover:bg-slate-50 transition-colors rounded-lg"
            >
              Vision
            </Link>
            <div className="px-4">
              <Button
                onClick={scrollToForm}
                className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white"
              >
                Diventa Fondatore
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
